<template>
  <div>
    <div>
      <!-- Content goes here -->
      <div v-if="isLoading">
        <Spinner />
      </div>
      <div v-else class="">
        <div class="Polaris-DataTable__Navigation">
          <button
            class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantTertiary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconOnly Polaris-Button--disabled"
            aria-label="Scroll table left one column"
            aria-disabled="true"
            type="button"
            tabindex="-1"
          >
            <span class="Polaris-Button__Icon">
              <span class="Polaris-Icon">
                <svg
                  viewBox="0 0 20 20"
                  class="Polaris-Icon__Svg"
                  focusable="false"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.764 5.204a.75.75 0 0 1 .032 1.06l-3.516 3.736 3.516 3.736a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z"
                  ></path>
                </svg>
              </span>
            </span>
          </button>
          <button
            class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantTertiary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconOnly"
            aria-label="Scroll table right one column"
            type="button"
          >
            <span class="Polaris-Button__Icon">
              <span class="Polaris-Icon">
                <svg
                  viewBox="0 0 20 20"
                  class="Polaris-Icon__Svg"
                  focusable="false"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.72 14.53a.75.75 0 0 1 0-1.06l3.47-3.47-3.47-3.47a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0Z"
                  ></path>
                </svg>
              </span>
            </span>
          </button>
        </div>
        <div class="Polaris-DataTable">
          <div class="Polaris-DataTable__ScrollContainer">
            <table class="Polaris-DataTable__Table">
              <thead>
                <tr>
                  <th
                    data-polaris-header-cell="true"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                    scope="col"
                  >
                    Upsell Name
                  </th>
                  <th
                    data-polaris-header-cell="true"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                    scope="col"
                  >
                    Status
                  </th>
                  <th
                    data-polaris-header-cell="true"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                    scope="col"
                  >
                    Created At
                  </th>
                  <th
                    data-polaris-header-cell="true"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                    scope="col"
                  >
                    Condition
                  </th>
                  <th
                    data-polaris-header-cell="true"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                    scope="col"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="upsells.docs && upsells.docs.length === 0">
                  <td
                    colspan="5"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop text-center"
                  >
                    Create an upsell to increase your sales
                  </td>
                </tr>
                <tr
                  v-for="(upsell, index) of upsells.docs"
                  :key="index"
                  class="Polaris-DataTable__TableRow Polaris-DataTable--hoverable"
                >
                  <td
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                  >
                    {{ upsell.name }}
                  </td>
                  <td
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                  >
                    <div class="flex items-center gap-2">
                      <span
                        class="Polaris-Badge"
                        :class="getUpsellBadgeTone(upsell.status)"
                      >
                        <span
                          class="Polaris-Text--root Polaris-Text--visuallyHidden"
                        >
                          {{ getUpsellBadgeA11yTone(upsell.status) }}
                        </span>
                        <span class="Polaris-Text--root Polaris-Text--bodySm">{{
                          getUpsellStatus(upsell.status)
                        }}</span>
                      </span>
                    </div>
                  </td>
                  <td
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                  >
                    <span v-if="upsell.createdAt">
                      {{ upsell.createdAt | dateFilter }}
                    </span>
                  </td>
                  <td
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                  >
                    <span> {{ getLabelForCondition(upsell) }}</span>
                  </td>
                  <td
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop flex items-center"
                  >
                    <button
                      type="button"
                      class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantTertiary Polaris-Button--sizeMedium mr-2"
                      @click.stop="editUpsell(upsell)"
                    >
                      <span class="Polaris-Button__Icon">
                        <span class="Polaris-Icon">
                          <svg
                            style="fill:none"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="size-6"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                            />
                          </svg>
                        </span>
                      </span>
                    </button>
                    <button
                      type="button"
                      class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantTertiary Polaris-Button--sizeMedium"
                      @click.stop="gotoUpsellAnalytics(upsell)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        style="fill:none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="h-6 w-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
                        />
                      </svg>
                    </button>
                    <VSwitch
                      v-if="upsell.status != 'waiting_for_approval'"
                      :value="upsell.status === 'active'"
                      @input="toggleUpsell(upsell, $event)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :page="upsells" @pageChanged="loadPage" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

import Pagination from "../../components/Common/Pagination.vue";
import Spinner from "vue-simple-spinner";
import VSwitch from "../../components/Common/VSwitch.vue";

export default {
  name: "Campaigns",
  components: {
    Pagination,
    Spinner,
    VSwitch
  },
  filters: {
    dateFilter(value) {
      if (value) {
        return format(new Date(value * 1000), "h:mm a, MMM dd");
      }
      return "";
    }
  },
  data() {
    return {
      showModal: false,
      currentCampaign: null,
      isLoading: false
    };
  },
  computed: {
    upsells() {
      return this.$store.getters["Upsell/getUpsells"];
    }
  },
  created() {
    this.loadPage(1);
  },
  methods: {
    async loadPage(page) {
      this.isLoading = true;
      await this.$store.dispatch("Upsell/getUpsells", {
        page
      });
      this.isLoading = false;
    },
    closeModal() {
      this.currentCampaign = null;
      this.showModal = false;
    },
    openModal() {
      this.showModal = true;
    },
    createNew() {
      this.openModal();
    },
    onCreate() {
      this.loadCampaigns();
      this.closeModal();
    },
    getUpsellStatus(status) {
      switch (status) {
        case "waiting_for_approval":
          return "waiting for approval";

        default:
          return status;
      }
    },
    getUpsellBadgeTone(status) {
      switch (status) {
        case "active":
          return "Polaris-Badge--toneSuccess";
        case "waiting_for_approval":
          return "Polaris-Badge--toneWarning";
        case "inactive":
          return "Polaris-Badge--toneInfo";
        default:
          return "";
      }
    },
    getUpsellBadgeA11yTone(status) {
      switch (status) {
        case "active":
          return "Success";
        case "waiting_for_approval":
          return "Warning";
        case "inactive":
          return "Info";
        default:
          return "Status";
      }
    },

    toggleUpsell(upsell, isActive) {
      const nextStatus = isActive ? "active" : "inactive";
      this.$store
        .dispatch("Upsell/updateStatus", {
          upsellId: upsell.id,
          requestParams: { status: nextStatus }
        })
        .then(() => {
          this.loadPage(this.upsells.page);
        });
    },

    gotoUpsellAnalytics(upsell) {
      this.$router.push({
        name: "UpsellAnalytics",
        params: { upsellId: upsell.id }
      });
    },
    deleteCampaign(upsell) {
      this.$store
        .dispatch("Marketing/deleteCampaign", {
          campaignId: upsell.id
        })
        .then(() => {
          this.loadCampaigns();
        });
    },
    getLabelForCondition(upsell) {
      return `${upsell.sendAfterDays} days after ${upsell.sendAfter.replace(
        "_",
        " "
      )}`;
    },
    editUpsell(upsell) {
      this.$router.push({
        name: "CreateUpsell",
        query: { edit: upsell.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
